import { EnvironmentInjector, inject, Injectable, runInInjectionContext, Signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { PublicUserContextService } from '@rma/public/accounts/user';
import { map, Observable } from 'rxjs';
import { MetaUserData } from '../domain/fb-events.model';

export interface MetaPixelContext {
  /** User data to use with advanced matching for the meta pixel */
  user?: MetaUserData;
  /** If user is impersonated from RAdmin */
  isImpersonating?: boolean;
}

@Injectable({ providedIn: 'root' })
export class MetaPixelContextService {
  private readonly userService = inject(PublicUserContextService);
  private readonly injector = inject(EnvironmentInjector);
  private context?: Signal<MetaPixelContext>;

  public getContext(): MetaPixelContext {
    if (!this.context) {
      this.context = runInInjectionContext(this.injector, () => this.loadMetaContext());
    }

    return this.context();
  }

  private loadMetaContext(): Signal<MetaPixelContext> {
    const userData$: Observable<MetaPixelContext> = this.userService.currentUser$.pipe(
      map((user) => {
        if (!user) {
          return {};
        }

        return {
          isImpersonating: user.isImpersonating,
          user: {
            external_id: user.userId,
            em: user.email?.toLowerCase().trim(),
            fn: user.firstname?.toLowerCase().trim(),
            ln: user.lastname?.toLowerCase().trim(),
          },
        };
      }),
    );
    return toSignal(userData$, { initialValue: {} });
  }
}
